import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ActionListLeadActivity extends ValueObject
{
    public leadActivityId: number = 1;
    
    public leadActivity: string = "New reply Recieved"
}
